import { useMemo } from 'react';
import { cn } from '../utils/cn';
import { formatLocalDateTime, getServerTimeTooltip, parseEsTimestamp } from '../utils/timestamps';

interface LocalizedTimestampProps {
  value: Date | string;
  className?: string;
}

export function LocalizedTimestamp({ value, className }: LocalizedTimestampProps) {
  const date = useMemo(
    () => (typeof value === 'string' ? parseEsTimestamp(value) : value),
    [value],
  );

  const localLabel = useMemo(() => formatLocalDateTime(date), [date]);
  const tooltip = useMemo(() => getServerTimeTooltip(date), [date]);

  return (
    <span className={cn('cursor-default tabular-nums', className)} title={tooltip}>
      {localLabel}
    </span>
  );
}
